import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import s from "./textController.module.scss";

type InputProps = {
  label: string,
  type: string,
  placeholder?: string,
  setValue?: (value: string) => void
  disabled?: boolean
  asTextarea?: boolean
  displayValue?: string
  showRequiredIndicator?: boolean
}

export const TextController = <T extends FieldValues>({
  name,
  control,
  ...props
}: UseControllerProps<T> & InputProps) => {

  const { field, fieldState } = useController({ name, control });

  return (
    <div className={s.inputContainer}>
      <label className={s.label}>{props.label}{props.showRequiredIndicator && <span className={s.requiredIndicator}> *</span>}</label>
      {props.asTextarea ?
        <textarea
          className={[s.input, fieldState.error ? s.error : ''].join(' ')}
          placeholder={`${props.placeholder || props.label + '...'}`}
          name={props.label}
          disabled={props.disabled}
          value={props.displayValue || field.value}
          rows={8}
          onChange={(e) => field.onChange(e.target.value)}
        />
        :
        <input
          className={[s.input, fieldState.error ? s.error : ''].join(' ')}
          placeholder={`${props.placeholder || props.label + '...'}`}
          type={props.type}
          name={props.label}
          disabled={props.disabled}
          value={props.displayValue || field.value}
          onChange={(e) => field.onChange(e.target.value)}
        />
      }
      {fieldState.invalid && (
        <div className={s.errorText}>
          <p>
            {fieldState.error?.message || ''}
          </p>
        </div>
      )}
    </div>
  );
}